import { styled } from "theme/default/styled";

export const SSupportPageQuestionIconRotated = styled.div`
  transform: rotate(180deg);
`;
